var vars = require('./core');

module.exports = vars.createClass('Doughnut', ['getSegmentsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/lib/doughnut.js
 ** module id = 969
 ** module chunks = 2
 **/